import{createContext as r,useContext as e}from"react";var o=r({}),t=function(){var r=e(o);return r||console.warn("PaperContext cannot be used outside Provider"),r};export{o as PaperContext,t as default};
